import { query, serviceQueries } from '@estee/elc-service-bus';
import { makeServiceQuery } from './MakeServiceQuery';

type TQueryProps = {
    queryName: string;
    parameters: unknown;
};

const makeServiceBusQuery = ({ queryName, parameters }: TQueryProps) =>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    query((serviceQueries as any)?.[queryName] || queryName, parameters);
const makeWindowQuery = ({ queryName, parameters }: TQueryProps) =>
    makeServiceQuery(queryName as string, parameters);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const makeQuery = (queryName: string, parameters: any) =>
    Promise.race([
        makeServiceBusQuery({ queryName, parameters }),
        makeWindowQuery({ queryName, parameters })
    ]);
